export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 32 32" className={className} aria-hidden="true">
    <rect width="32" height="32" rx="8" fill="#131924" stroke="rgba(212,175,55,.35)" />
    <path d="M7 6.5h4.5v19H7z" fill="#D4AF37" />
    <path d="M25 6.5 15.5 16 25 25.5" fill="none" stroke="#D4AF37" strokeWidth="4" />
  </svg>
);

export const Logo = ({ onClick }) => (
  <button onClick={onClick} data-testid="nav-brand-logo" className="group flex items-center gap-3">
    <LogoMark className="h-9 w-9 transition-transform duration-500 group-hover:rotate-[-8deg]" />
    <span className="text-left leading-none">
      <span className="font-display block text-[17px] font-semibold tracking-tight text-white">Kinara Works</span>
      <span className="font-mono-k block text-[10px] uppercase tracking-[0.25em] text-slate-400 mt-1">Co-Working · Noida</span>
    </span>
  </button>
);
